module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"RequestStatistic":"Todo statistic","InTheLast30Days":"In the last 30 days","Reject":"Reject","Waiting":"Waiting","Done":"Done"},"vi":{"RequestStatistic":"Thống kê đề xuất","InTheLast30Days":"Trong 30 ngày gần nhất","Reject":"Từ chối","Waiting":"Chờ duyệt","Done":"Hoàn tất"}}')
  delete Component.options._Ctor
}
